import { accentForegroundHover, accentForegroundRest, bodyFont, neutralForegroundRest, typeRampBaseFontSize, typeRampBaseLineHeight } from "@fluentui/web-components";
import { css } from "@microsoft/fast-element";
import { display } from "@microsoft/fast-foundation";
export const errorCardStyles = (context, definition) => css `
    ${display("inline-flex")} :host {
        font-family: ${bodyFont};
        flex-flow: column nowrap;
        width: 100%;
        height: 100%;
        justify-content: center;
        align-items: center;
        font-size: ${typeRampBaseFontSize};
        font-weight: 400;
        line-height: ${typeRampBaseLineHeight};
        text-overflow: ellipsis;
      }

    text.large{
        font-weight: 600;
        line-height: 20px;
        color: ${neutralForegroundRest};
        display: inline;
        text-align: center;
        margin-bottom: 18px;
        margin-left: 50px;
        margin-right: 50px;
      }

    text.largeForSmallCard{
        margin-top: 15px;
        margin-left: 15px !important;
        margin-right: 15px !important;
        margin-bottom: 15px !important;
      }

    text.largeForSmallCardSubtext {
        margin-top: 15px;
        margin-left: 15px !important;
        margin-right: 15px !important;
        margin-bottom: 0px !important;
    }

    text.medium {
        font-weight: 400;
        line-height: 16px;
        color: ${neutralForegroundRest};
        display: inline;
        text-align: center;
        margin-left: 38px;
        margin-right: 38px;
        margin-bottom: 30px;
        font-size: 12px;
    }

    text.mediumForSmallCardSubtext {
        margin-bottom: 8px !important;
    }

    fluent-button {
        margin: -1px;
        padding: 1px;
        min-width: 150px;
    }

    a {
        color: ${accentForegroundRest};
        text-decoration-line: none;
    }

    a:active, a:hover {
        color: ${accentForegroundHover};
        text-decoration: underline;
    }

`;
